<template>
	<v-container fluid>
	  <v-snackbar v-model="snackbar" :color="snackbarColor" :top="true" :right="true" :timeout="6000" absolute>
		{{ message }}
		<v-btn dark text @click="snackbar = false">
		  CLOSE
		</v-btn>
	  </v-snackbar>
	  <v-row>
		<v-col cols="12">
		  <v-card min-height="530">
			<v-card-title>
			  <v-row>
				<v-col cols="4" md="2">
				  <v-btn color="#7BC243" @click="openCreateDialog" class="white--text cataloguebtn"
					v-if="$can('CAN_UPLOAD_CATALOGUE')"> New Broker Charge
				  </v-btn>
				</v-col>
				<v-spacer></v-spacer>
				<v-col cols="6" md="4">
				  <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details
					color="primary"></v-text-field>
				</v-col>
			  </v-row>
			</v-card-title>
			<v-card-text>
			  <v-data-table :headers="headers" :items="brokers" class="elevation-1" :search="search" disable-pagination
				:hide-default-footer="true">
				<template v-slot:[`header.id`]="{ header }">
				  <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
				</template>
				<template v-slot:[`header.growerCode`]="{ header }">
				  <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
				</template>
				<template v-slot:[`header.chargeRate`]="{ header }">
				  <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
				</template>
				<template v-slot:[`item.creationDate`]="{ item }">
				  {{ item.creationDate | prettyDate }}
				</template>
				<template v-slot:[`item.expiryDate`]="{ item }">
				  {{ item.expiryDate | prettyDate }}
				</template>
				<template v-slot:[`header.paidBy`]="{ header }">
				  <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
				</template>
				<template v-slot:[`header.status.statusName`]="{ header }">
				  <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
				</template>
				<template v-slot:[`item.status`]="{ item }">
				  <p v-if="item.status.id === 3"> Not Approved </p>
				  <p v-else> Approved </p>
				</template>
				<template v-slot:[`item.actions`]="{ item }">
				  <v-menu offset-y>
					<template v-slot:activator="{ on }">
					  <v-btn color="primary" v-on="on" text icon class="actions">
						<v-icon class="secondary--text"> more_horiz </v-icon>
					  </v-btn>
					</template>
					<v-list >
					  <v-list-item v-if="$can('CAN_APPROVE_CATALOGUE') || $can('CAN_APPROVE_CHARGE')" @click="approveChargeDialog(item)">
						<v-list-item-title> Approve </v-list-item-title>
					  </v-list-item>
					  <v-list-item v-if="$can('CAN_UPLOAD_CATALOGUE')">
						<!-- <v-icon @click="editItem(item)">mdi-pencil</v-icon> -->
						<v-list-item-title @click="editItem(item)"> Edit </v-list-item-title>
						</v-list-item>
					  <v-list-item v-if="$can('CAN_APPROVE_CATALOGUE') || $can('CAN_APPROVE_CHARGE')" @click="declineChargeDialog(item)">
						<v-list-item-title> Reject </v-list-item-title>
					  </v-list-item>
					</v-list>
				  </v-menu>
				</template>
			  </v-data-table>
			</v-card-text>
			<v-card-actions>
			  <v-row>
				<v-col cols="12" sm="9">
				  <v-pagination v-model="page" :length="totalPages" total-visible="7" next-icon="mdi-menu-right"
					prev-icon="mdi-menu-left" @input="handlePageChange"></v-pagination>
				</v-col>
			  </v-row>
			</v-card-actions>
		  </v-card>
		</v-col>
	  </v-row>
	  <v-dialog v-model="createDialog" max-width="600px" persistent>
		<v-card>
		  <v-card-title>
			<span class="headline">Create Broker Charge</span>
		  </v-card-title>
		  <v-card-text>
			<v-container grid-list-xl fluid>
			  <v-form ref="form" v-model="valid" lazy-validation>
				<v-layout wrap>
				  <v-flex xs4>
					<v-autocomplete name="benefactor" v-model="charge.growerCode" :items="benefactors"
					  item-text="organisationName" item-value='organisationCode' @input="validateSelectedItem"
					  label="Grower" v-if="benefactorsField" required>
					  >
					</v-autocomplete>
					<p v-if="!isValidSelection" style="color: red;">Please select a valid item.</p>

				  </v-flex>
				  <v-flex xs6>
					<label for="chargeRate">ChargeRate(%)</label>
					<input type="number" id="chargeRate" v-model="charge.chargeRate" @input="validateNumericInput"
					  placeholder="0" required />
					<p v-if="!isValidNumericInput" style="color: red;">Please Enter a valid Charge Rate.</p>
				  </v-flex>
				  <v-flex xs6>
					<label for="contractstartdate">Contract Start Date </label>
					<input type="date" id="datepicker" label="Contract Start Date" v-model="charge.creationDate"
					  @input="validateDates" required />
				  </v-flex>
				  <v-flex xs6>
					<label for="contractenddate">Contract End Date</label>
					<input type="date" id="datepicker" v-model="charge.expiryDate" @input="validateDates" required />
					<p v-if="isValidDateRange" style="color: red;">End date must be greater than start date.</p>
				 </v-flex>
				  <v-flex id="fileupload" xs12>
					<label for="contract">Contract </label>
					<input type="file" id="file" ref="file" :disabled="isDisabled" v-on:change="handleFileUpload()" required>
				  </v-flex>
				</v-layout>
			  </v-form>
			</v-container>
		  </v-card-text>
		  <v-card-actions>
			<v-btn color="primary" @click="closeCreateDialog"> Cancel </v-btn>
			<v-spacer> </v-spacer>
			<v-btn color="secondary" v-if="isButtonEnabled" @click="handleProcessBroker"> Create</v-btn>
		  </v-card-actions>
		</v-card>
	  </v-dialog>

	  <v-dialog v-model="editBrokerCharge" persistent max-width="500">
		  <template>
			<v-card>
		  <v-card-title>
			<span class="headline">Update Broker Charge</span>
		  </v-card-title>
		  <v-card-text>
			<v-container grid-list-xl fluid>
			  <v-form ref="form" v-model="valid" lazy-validation>
				<v-layout wrap>
				  <v-flex xs4>
					<v-autocomplete name="benefactor"
					item-value="value"
					v-model="bcharge.editgrowerCode" :items="this.bcharge.editgrowerCode"
					  item-text="organisationName" @input="validateSelectedItem"
					  label="Grower" v-if="benefactorsField" required>
					</v-autocomplete>
					<p v-if="!isValidSelection" style="color: red;">Please select a valid item.</p>

				  </v-flex>
				  <v-flex xs6>
					<label for="chargeRate">ChargeRate(%)</label>
					<input type="number" id="chargeRate" v-model="bcharge.editChargeRate"  item-value="value"
					 @input="validateNumericInput"
					  placeholder="0" required />
					<p v-if="!isValidNumericInput" style="color: red;">Please Enter a valid Charge Rate.</p>
				  </v-flex>
				  <v-flex xs6>
					<label for="contractstartdate">Contract Start Date </label>
					<input type="date" id="datepicker" label="Contract Start Date"  v-model="this.bcharge.editCreationDate"
					  @input="validateDates" required />
				  </v-flex>
				  <v-flex xs6>
					<label for="contractenddate">Contract End Date</label>
					<input type="date" id="datepicker" v-model="bcharge.editExpiryDate" @input="validateDates" required />
					<p v-if="isValidDateRange" style="color: red;">End date must be greater than start date.</p>


				  </v-flex>
				  <v-flex id="fileupload" xs12>
					<label for="contract">Contract </label>
					<input type="file" id="editfile" ref="editfile" v-on:change="handleFileUpload()" required>
				  </v-flex>
				</v-layout>
			  </v-form>
			</v-container>
		  </v-card-text>
		  <v-card-actions>
			<v-btn color="primary" @click="closeEditDialog"> Cancel </v-btn>
			<v-spacer> </v-spacer>
			<v-btn color="secondary" v-if="isButtonEnabled" @click="handleEditBroker"> Update</v-btn>
		  </v-card-actions>
		</v-card>
		  </template>
		</v-dialog>

	  <v-dialog v-model="approveDialog" max-width="600px" persistent>
		<v-card>
		  <v-card-title class="body-2 accent--text font-weight-bold">Approve Charge</v-card-title>

		  <v-card-text class="accent--text">
			Confirm approval of charge
		  </v-card-text>

		  <v-card-actions>
			<v-btn color="secondary"
                class="accent--text logoutbtn" flat="flat" @click="closeApproveChargeDialog" >
			  Cancel
			</v-btn>
			<v-spacer></v-spacer>
			<v-btn color="#7BC243" class="white--text confirmbtn" @click="approveCharge">
			  Approve
			</v-btn>
		  </v-card-actions>
		</v-card>
	  </v-dialog>
	  <v-dialog v-model="declineDialog" max-width="600px" persistent>
		<v-card>
		  <v-card-title class="body-2 accent--text font-weight-bold">Decline Charge</v-card-title>

		  <v-card-text class="accent--text">
			Confirm decline of charge
		  </v-card-text>

		  <v-card-actions>
			<v-btn color="secondary"
                class="accent--text logoutbtn" flat="flat" @click="closeDeclineChargeDialog" >
			  Cancel
			</v-btn>
			<v-spacer></v-spacer>
			<v-btn color="#7BC243" class="white--text confirmbtn" @click="declineCharge">
			  Decline
			</v-btn>
		  </v-card-actions>
		</v-card>
	  </v-dialog>
	</v-container>
  </template>
  <script>
  import axios from 'axios'
  import config from '../../../config'
  import _ from 'lodash'

  export default {
	name: 'BrokerCharges',
	data: function () {
	  return {
		createDialog: false,
		isDisabled:false,
		isButtonEnabled: true,
		isValidDateRange: false,
		isValidNumericInput: true,
		selectedItem: null,
		isValidSelection: true,
		editBrokerCharge: false,
		charge: {
		  'growerCode': '',
		  'chargeRate': '',
		  'paidTime': new Date(),
		  'creationDate': '',
		  'expiryDate': '',
		  'paidBy': 'broker_maker',
		  'lastUpdateDate': new Date(),
		  'creationDate': new Date()
		},
		bcharge: {
		  'editgrowerCode': '',
		  'editChargeRate': '',
		  'paidTime': new Date(),
		  'editCreationDate': '',
		  'editExpiryDate': '',
		  'paidBy': 'broker_maker',
		  'lastUpdateDate': new Date(),
		  'creationDate': new Date()
		},
		curUser: {},
		curUserN: '',
		editDialog: false,
		benefactors: [],
		beneficiaries: [],
		currencies: [],
		millers: [],
		warehouse: [],
		brokers: [],
		unitOfMeasures: [],
		snackbarColor: '',
		message: '',
		brocker: '',
		miller: '',
		grower: '',
		currency: '',
		fileType: '',
		unitofMeasure: '',
		contractStartDate: null,
		contractEndDate: null,
		bagRate: 0,
		pocketRate: '',
		gracePeriod: '',
		perDayPerBagCharge: '',
		contract: '',
		snackbar: false,
		deductionValueRules: [
		  v => !!v || 'Deduction value is required'
		],
		nonMarketers: [],
		marketers: [],
		valid: true,
		fsc: [],
		bankorgs: [],
		statutoryorgs: [],
		benefactorsField: true,
		chargeSelected: {},
		approvedcharges: [],
		unapprovedcharges: [],
		charges: [],
		approveDialog: false,
		declineDialog: false,
		selectedWarehouseCharge: {},
		headers: [
		  { text: '#', value: 'id' },
		  { text: 'Grower Code', value: 'growerCode' },
		  { text: 'Charge Rate', value: 'chargeRate' },
		  { text: 'Start Date', value: 'creationDate' },
		  { text: 'End Date', value: 'expiryDate' },
		  // { text: 'Paid Time', value: 'paidTime' },
		  { text: 'Status', value: 'status.statusName' },
		  { text: 'Actions', value: 'actions', sortable: false }
		],
		nameRules: [
		  v => !!v || 'Charge Rate  is required',
		  v => (v && v.length <= 10) || 'Charge Rate must be less than 10 characters',
		],
		search: '',
		page: 1,
		totalPages: 0,
		pageSize: 5,
		pageSizes: [5, 10],
		deductions: []
	  }
	},
	watch: {
	  search: function (oldValue, newValue) {
		this.debouncedGetAnswer()
	  }
	},
	mounted() {
	  this.isBroker()
	  this.getLoggedInUser()
	  this.getBrokers()
	  this.getFCS()

	},
	methods: {
	  bcharge: {
		  'editgrowerCode': '',
		  'editChargeRate': '',
		  'paidTime': new Date(),
		  'editCreationDate': '',
		  'editExpiryDate': '',
		  'paidBy': 'broker_maker',
		  'lastUpdateDate': new Date(),
		  'creationDate': new Date()
		},



	  editItem (item) {
			  console.log('Broker Item -> ', item)
		const crDate = new Date(item.creationDate);
		const expDate = new Date(item.expiryDate);
		this.formattedCrDate = crDate.toLocaleDateString();
		this.formattedExpDate = expDate.toLocaleDateString();
			  this.editBrokerCharge = true
			  this.bcharge.editgrowerCode = item.growerCode
		this.bcharge.editChargeRate = item.chargeRate
		this.bcharge.paidTime = item.paidTime
		this.bcharge.editCreationDate = crDate
		this.bcharge.editExpiryDate = expDate
		this.bcharge.paidBy = item.paidBy
		this.bcharge.lastUpdateDate = item.lastUpdateDate
		this.bcharge.creationDate = item.creationDate

		  },


	  handleEditBroker () {
		var url = config.serverURI + '/user/internaluser/update'
		console.log(this.bcharge)
		axios.post(url, this.bcharge)
		  .then(response => {
			this.message = response.data.message
			if (response.data.error) {
			  this.snackbarColor = 'error'
			} else {
			  this.snackbarColor = 'primary'
			}
			this.snackbar = true
		  })
		  .catch(error => {
			// Request failed.
			console.log('error', error.response)
			this.snackbarColor = 'error'
			this.snackbar = true
		  })
	  },
	  getLoggedInUser() {
		this.curUser = JSON.parse(localStorage.getItem("user"))
		this.curUserN = this.curUser.username
		// console.log('Currently Logged In user========>' + JSON.stringify(this.curUser))
	  },
	  isBroker() {
		// console.log('curUserN =====>'+this.curUserN.toLowerCase().includes('broker_maker'))
		if (this.curUserN.toLowerCase().includes('broker_maker')) {
		  return false
		} else {
		  return true
		}
	  },
	  handleFileUpload() {
		this.fileType = this.getFileType(this.getFileType(this.$refs.file.files[0].name));
		if (this.fileType === 'pdf') {
		  this.file = this.$refs.file.files[0]
		  this.isButtonEnabled = true;
		} else {
		  this.isButtonEnabled = false;
		  alert('Invalid File Type. Kindly upload PDF Files Only!!');
		}
	  },
	  getFileType(fileName) {
		const fileExtension = fileName.split('.').pop().toLowerCase();
		return fileExtension;
	  },
	  validateSelectedItem() {

		this.isValidSelection = this.selectedItem !== null ? false : true;
	  },
	  validateNumericInput() {
		this.isValidNumericInput = this.isNumeric(this.charge.chargeRate) && (this.charge.chargeRate <= 100) && (this.charge.chargeRate > 0) && (this.charge.chargeRate !== '') && (this.charge.chargeRate !== 0); //? true : false;
	  },
	  isNumeric(value) {
		return !isNaN(parseFloat(value)) && isFinite(value);
	  },
	  isPercentage(value) {
		const percentageRegex = /^(\d+\.?\d*|\.\d+)%$/;
		return percentageRegex.test(value);
	  },
	  handleProcessBroker() {
		if (file.files.length === 0 && !!this.charge.growerCode == false && !!this.charge.chargeRate == false) {
			this.isDisabled =false;
			//isValidDateRange, isValidNumericInput ,selectedItem isDisabled
			alert('Please check your input!!');
		  return;
		} else {
		this.isDisabled =true;
		  this.uploadContract();
		  this.createCharge();
		}

	  },
	  uploadContract() {
		if (this.$refs.form.validate()) {
		  this.showProgressBar = true
		  const url = config.serverURI + ' /api/file/upload'
		  const formData = new FormData()
		  formData.append('file', this.file)

		  axios({ url: url, method: 'POST', responseType: 'blob', data: formData })
			.then(response => {
			  this.uploadFileDialog = false
			  // if (response.data.error === false) {
			  this.snackbar = true
			  this.snackbarColor = 'primary'
			  this.message = 'Success'
			  // } else {
			  //   this.message = 'Failed uploading'
			  //   this.snackbar = true
			  //   this.snackbarColor = 'error'
			  // }

			  this.getUploadedFiles()
			})
			.catch(error => {
			  // console.log('error', error.response)
			  if (error.response.status === 424) {
				this.message = 'Failed:: review  downloaded Files for errors'
				const url = window.URL.createObjectURL(new Blob([error.response.data], { type: 'application/vnd.ms-excel' }))
				const link = document.createElement('a')
				link.href = url
				const itemFileName = 'File_With_Error_' + this.file.name
				link.setAttribute('download', itemFileName)
				document.body.appendChild(link)
				link.click()
			  } else {
				Common.blobToJson(error.response.data)
				  .then(jsonData => {
					this.message = typeof jsonData.message !== 'undefined' ? jsonData.message : error.response.status + ' Request failed'
				  })
				  .catch(error => {
					console.error('Error:', error)
					this.message = typeof error.response.data.message !== 'undefined' ? error.response.data.message : error.response.status + ': Error occurred'
				  })
			  }

			  // this.message = typeof error.response.data.message !== 'undefined' ? error.response.data.message : error.response.status
			  this.snackbar = true
			  this.snackbarColor = 'error'
			  this.uploadFileDialog = false
			})
			.finally(() => {
			  this.showProgressBar = false
			})
		  this.handleFileUpload()
		}
	  },
	  openCreateDialog() {
		this.createDialog = true
	  },
	  getCurrencies() {
		var url = config.serverURI + '/organization/currency'
		axios.get(url)
		  .then(response => {
			if (response.status !== 200) {
			  console.log('Error is ' + this.error)
			  return
			}
			this.currencies = response.data
		  })
		  .catch(error => {
			console.log('error', error.response)
		  })
	  },
	  getMillers: function () {
		const url = config.serverURI + '/organization/getMillers'
		axios.post(url)
		  .then(response => {
			this.millers = response.data
		  })
		  .catch(error => {
			this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.data ? error.response.data.message : 'Error ocurred' })
		  })
		return this.organisations
	  },
	  getBrokers() {
		const params = this.getRequestParams(this.search, this.page, this.pageSize)
		const url = config.serverURI + '/charges/broker'
		axios.get(url, { params })
		  .then(response => {
			const { items, totalPages } = response.data
			this.brokers = items
			this.totalPages = totalPages
			console.log('Response', items)
		  })
		  .catch(error => {
			this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.message })
		  })
		// console.log('Broker Charges: ==>>', this.brokers)
		return this.brokers
	  },
	  getWarehouse: function () {
		const url = config.serverURI + '/organization/getWarehouse'
		axios.post(url)
		  .then(response => {
			this.warehouse = response.data
		  })
		  .catch(error => {
			this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.data ? error.response.data.message : 'Error ocurred' })
		  })
		return this.organisations
	  },
	  brockerChanged() {
		const chargeNameSelected = this.charge.chargeType
		const chargeSelectedArr = this.chargeTypes.filter((charge) => charge.chargeName === chargeNameSelected)
		this.chargeSelected = chargeSelectedArr[0]
		if (this.chargeSelected.chargeType.id === 1) { // government
		  this.benefactorsField = false
		  this.beneficiaries = this.statutoryorgs
		} else if (this.chargeSelected.chargeType.id === 4) { // marketer
		  this.benefactorsField = true
		  this.benefactors = this.fcs
		  this.beneficiaries = this.marketers
		} else if (this.chargeSelected.chargeType.id === 3) { // bank comissions
		  this.benefactorsField = false
		  this.beneficiaries = this.bankorgs
		} else { // contractual
		  this.benefactors = this.fcs
		  this.beneficiaries = this.nonMarketers
		  this.benefactorsField = true
		}
	  },
	  closeCreateDialog() {
		this.createDialog = false
		this.charge = {}
		this.$refs.form.resetValidation()
	  },
	  closeEditDialog() {
		this.editBrokerCharge = false
		this.charge = {}
		this.$refs.form.resetValidation()
	  },
	  validateChargeRate() {
		this.isValidDateRange = true;
		this.isButtonEnabled = false;
	  },
	  validateDates() {
		const startDateObj = new Date(this.charge.creationDate);
		const endDateObj = new Date(this.charge.expiryDate);

		// Compare the dates
		if (startDateObj > endDateObj) {
		  this.isValidDateRange = true;
		  this.isButtonEnabled = false;
		} else {
		  this.isValidDateRange = false;
		  this.isButtonEnabled = true;
		}
	  },
	  createCharge() {
		if (this.$refs.form.validate()) {
		  // Begin
		  console.log(this.charge.chargeRate)
		  if(this.isValidNumericInput){
			this.createDialog = false
			const url = config.serverURI + '/charges/create/broker'
			// console.log('Dates :' + JSON.stringify(this.charge))
			console.log('Dates :' + this.charge.creationDate + ' ' + this.charge.expiryDate)
			axios.post(url, this.charge)
			  .then(response => {
				// console.log(response.data)
				if (response.data.error !== false) {
				  this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: 'All Fields Mandatory' })
				  return
				}
				this.getCharges()
				this.charge = {}
				this.$refs.form.resetValidation()
				this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'primary', message: response.data.message })
				this.getBrokers()
			  })
			  .catch(error => {
				this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.message })
			  })
			}
		}else{
		  this.isButtonEnabled = false;
		}
	  },
	  getMarketers() {
		const url = config.serverURI + '/organization/get-marketers'
		axios.get(url)
		  .then(response => {
			this.marketers = response.data
		  })
		  .catch(error => {
			this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.message })
		  })
	  },
	  getNonMarketers() {
		const url = config.serverURI + '/organization/get-non-marketers'
		axios.get(url)
		  .then(response => {
			this.nonMarketers = response.data
		  })
		  .catch(error => {
			this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.message })
		  })
	  },
	  getFCS() {
		const url = config.serverURI + '/organization/get-fcs'
		axios.get(url)
		  .then(response => {
			this.benefactors = response.data
			// console.log('Growers     ' + this.benefactors)
		  })
		  .catch(error => {
			this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.message })
		  })
	  },
	  getDeductionTypes() {
		const url = config.serverURI + '/charges/deductiontype'
		axios.get(url)
		  .then(response => {
			this.deductionTypes = response.data
		  })
		  .catch(error => {
			this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.message })
		  })
	  },
	  getMeasureTypes() {
		const url = config.serverURI + '/charges/deductionmeasures'
		axios.get(url)
		  .then(response => {
			this.unitOfMeasures = response.data
		  })
		  .catch(error => {
			this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.message })
		  })
	  },
	  getBankOrgs() {
		const url = config.serverURI + '/organization/get-bank-org'
		axios.get(url)
		  .then(response => {
			this.bankorgs = response.data
		  })
		  .catch(error => {
			this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.message })
		  })
	  },
	  getChargeTypes() {
		const url = config.serverURI + '/charges/charges'
		axios.get(url)
		  .then(response => {
			this.chargeTypes = response.data
		  })
		  .catch(error => {
			this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.message })
		  })
	  },
	  getStatutoryOrgs() {
		const url = config.serverURI + '/organization/get-statutory-org'
		axios.get(url)
		  .then(response => {
			this.statutoryorgs = response.data
		  })
		  .catch(error => {
			this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.message })
		  })
	  },
	  getRequestParams(name, page, pageSize) {
		const params = {}
		if (page) {
		  params.page = page - 1
		}
		if (pageSize) {
		  params.size = pageSize
		}
		if (name) {
		  params.benefactorName = name
		}
		return params
	  },
	  handlePageChange(value) {
		this.page = value
		this.getCharges()
	  },
	  handlePageSizeChange(size) {
		this.pageSize = size
		this.page = 1
		this.getCharges()
	  },
	  getCharges() {
		const params = this.getRequestParams(this.search, this.page, this.pageSize)
		const url = config.serverURI + '/charges/brokers'
		axios.get(url, { params })
		  .then(response => {
			const { items, totalPages } = response.data
			this.deductions = items
			this.totalPages = totalPages
		  })
		  .catch(error => {
			this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.message })
		  })
	  },
	  approveChargeDialog(item) {
		//console.log('Items :  ===>'+ JSON.stringify(item))
		this.approveDialog = true
		this.selectedWarehouseCharge = item
	  },
	  declineChargeDialog(item) {
		this.declineDialog = true
		this.selectedWarehouseCharge = item
	  },
	  closeApproveChargeDialog() {
		this.approveDialog = false
	  },
	  closeDeclineChargeDialog() {
		this.declineDialog = false
	  },
	  approveCharge() {
		const token = localStorage.getItem("token");
		const tokenconfig = { headers: { Authorization: `Bearer ${token}` } };
		const url = config.serverURI + '/charges/broker/approve'
		//  axios.post(url, this.selectedWarehouseCharge)
		axios.post(url, this.selectedWarehouseCharge, tokenconfig)
		  .then(response => {
			this.closeApproveChargeDialog()
			this.getCharges()
			this.getBrokers()
			this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'primary', message: response.data.message })
		  })
		  .catch(error => {
			this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.message })
		  })
	  },
	  declineCharge() {
		const url = config.serverURI + '/charges/decline'
		axios.post(url, this.selectedWarehouseCharge)
		  .then(response => {
			this.closeDeclineChargeDialog()
			this.getCharges()
			this.getBrokers()
		  })
		  .catch(error => {
			this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.message })
		  })
	  }

	},
	created: function () {
	  this.debouncedGetAnswer = _.debounce(this.getCharges, 1000)
	},
	approveChargeDialog(item) {
	  //console.log('Items :  ===>'+ JSON.stringify(item))
	  this.approveDialog = true
	  this.selectedWarehouseCharge = item
	},
	declineChargeDialog(item) {
	  this.declineDialog = true
	  this.selectedWarehouseCharge = item
	},
  }

  </script>
  <style>
  #fileupload {
	display: flex;
	flex-direction: row;
	align-items: center;
  }

  .charge_box_empty {
	position: relative;
	background: #fff;
	border: 1px solid #707070;
  }

  .charge_box {
	position: relative;
	background: #fff;
	border: 1px solid #707070;
  }

  .charge_box:after,
  .charge_box:before {
	right: 100%;
	top: 17%;
	border: solid transparent;
	content: " ";
	height: 0;
	width: 0;
	position: absolute;
	pointer-events: none;
  }

  .charge_box:after {
	border-color: rgba(255, 255, 255, 0);
	border-right-color: #fff;
	border-width: 20px;
	margin-top: -20px;
  }

  .charge_box:before {
	border-color: rgba(112, 112, 112, 0);
	border-right-color: #707070;
	border-width: 21px;
	margin-top: -21px;
  }

  .confirmbtn {
	font-weight: 700;
	border-radius: 8px;
  }

  .error {
	border: 1px solid red;
  }

  .error-message {
	color: red;
  }
  </style>
